import { render } from "./ClientInvoicesTable.vue?vue&type=template&id=5cc1c460&scoped=true"
import script from "./ClientInvoicesTable.vue?vue&type=script&lang=js"
export * from "./ClientInvoicesTable.vue?vue&type=script&lang=js"

import "./ClientInvoicesTable.vue?vue&type=style&index=0&id=5cc1c460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc1c460"]])

export default __exports__